import React from 'react';
import PropTypes from 'prop-types';

import {SVGIcon} from '@homeaway/react-svg';

import {useComponent} from './hooks';

import './SearchIcon.less';

function SearchIcon(props) {
    const {
        smallIconClassName,
        largeIconClassName,
        smallIconMarkup,
        largeIconMarkup
    } = useComponent(props);

    return (
        <>
            <SVGIcon
                className={smallIconClassName}
                markup={smallIconMarkup}
            />
            <SVGIcon
                className={largeIconClassName}
                markup={largeIconMarkup}
            />
        </>
    );
}

SearchIcon.propTypes = {
    iconName: PropTypes.string.isRequired
};

export {SearchIcon};
